import { cloneDeep } from "lodash";
import {
    allBudgetTypesOptions,
    allClassificationTypesOptions,
    allDataSourcesOptions,
    allDevelopTypesOptions,
    allMeasureUnitsOptions,
    allMutuallyRedeemingLevelOptions,
    allMutuallyRedeemingOptions,
    allPaymentTypesOptions,
    allPeriodicitiesOptions,
    allReportNamesOptions,
    allReportTypesOptions,
    allSegmentationOptions
} from "../../common/baseOptions";
import { Classificator } from "../../common/types/Classificator";
import { Indicator } from "../../common/types/Indicator";
import { Template } from "../../common/types/Template";
import { ReportDkiRFilterSettings } from "./settings/ReportDkiRFilterSettings";
import { ReportDkiRFilterOptions } from "./options/ReportDkiRFilterOptions";

export const reportDkiRExpensesClassificators: Classificator[] = [
    { key: 'gr', active: true, selected: [] },
    { key: 'pgr', active: true, selected: [] },
    { key: 'abp', active: true, selected: [] },
    { key: 'prg', active: true, selected: [] },
    { key: 'ppr', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] }
]

/** Показатели «План» / «Касса» / «Остатки» (RQ.eAk.RcDkiR.19) */
export const reportDkiRIndicators: Indicator[] = [
    { key: 'plan', active: true },
    { key: 'cash', active: true },
    { key: 'balance', active: true }
]

/** Все 12 месяцев блока «в том числе по месяцам» (RQ.eAk.RcDkiR.20), по умолчанию все включены */
export const reportDkiRMonths: Indicator[] = Array.from({ length: 12 }, (_, i) => ({
    key: String(i + 1),
    active: true
}))

/** Разрезность по умолчанию — активна только «КБК» (RQ.eAk.RcDkiR.23) */
export const reportDkiRSegmentations = cloneDeep(allSegmentationOptions).map(it => ({
    ...it,
    active: it.value === 'KBK'
}))

// Нужна как временная затычка (При созданий нового берутся пустые настройки)
const tempSettings: ReportDkiRFilterSettings = {
    // Base:
    reportName: 'DKI-R',
    reportType: 'REGULATED',
    classificationType: 'EXPENSES',
    dataSource: 'IISK',
    periodicity: 'DAY',
    // Custom:
    region: '',
    date: '',
    measureUnit: 'THOUSAND',
    roundUpTo: null,
    budgetTypes: [],
    paymentType: 'PAYMENTS',
    mutuallyRedeeming: 'WITH',
    mutuallyRedeemingLevels: [],
    segmentations: cloneDeep(reportDkiRSegmentations),
    isTree: true,
    expenseTotal: false,
    developType: null,
    expenses: cloneDeep(reportDkiRExpensesClassificators),
    indicators: cloneDeep(reportDkiRIndicators),
    months: reportDkiRMonths.map(it => Number(it.key))
}

export const reportDkiRBaseTemplate: Template = {
    id: null,
    name: 'Динамика кассового исполнения плана финансирования',
    excelName: null,
    description: null,
    category: '60',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}

export const reportDkiRFilterOptions: ReportDkiRFilterOptions = {
    // Base:
    key: 'DKI-R',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions),
    dataSources: cloneDeep(allDataSourcesOptions),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    // Custom:
    regions: [], // Загружается с бэка
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    expenses: cloneDeep(reportDkiRExpensesClassificators),
    paymentTypes: cloneDeep(allPaymentTypesOptions),
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    segmentations: cloneDeep(allSegmentationOptions),
    developTypes: cloneDeep(allDevelopTypesOptions),
    indicators: cloneDeep(reportDkiRIndicators)
}
